export const iconFontAwesomeNatureSeedling = (
	<i className="fa-solid fa-seedling"></i>
);
